import { Route } from '@angular/router';
import { LayoutPageComponent } from './pages/layout-page/layout-page.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from '@vallia-doc-flow/ui-auth';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: LayoutPageComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'admin',
        loadChildren: () => import('./admin.routes').then(mod => mod.adminRoutes),
      },
      {
        path: 'user',
        loadChildren: () => import('./user.routes').then(mod => mod.userRoutes),
      },
      {
        path: 'playground',
        loadChildren: () => import('./testAnalysis.routes').then(mod => mod.testAnalysisRoutes),
      },
      {
        path: '',
        pathMatch: 'prefix',
        redirectTo: 'admin',
      },
    ],
  },
];
